<!-- 单位付款审核 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <supplierBankAction v-if="showStatus" ref="supplierBankAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></supplierBankAction>
        </el-drawer>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" :flagList="['']" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform></vSearch>
                <span style="font-size: 20px;">合计: <span>{{ allMoney }}</span></span>
            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
                <el-table-column label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField" :min-width="tableValye.fieldWeight" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
                                {{ scope.row.isWms == 0 ? '否' : '是' }}
                            </el-tag>
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'psomState'">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row.psomState) }}</el-tag>
                            <span v-else-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.fieldType == 'formatter'">
                                <span v-for="(item, index) in JSON.parse(tableValye.formatterContent)" :key="index">
                                    <span v-if="item.key == scope.row[tableValye.entityField]">
                                        <el-tag size="mini">{{ item.value }}</el-tag>
                                    </span>
                                </span>
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                            </span>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>

        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <el-dialog title="确认付款" v-if="editVisible" :visible.sync="editVisible" width="500px" center>
            <el-form label-width="100px" class="baseForm">
                <el-row>
                    <el-form-item label="账簿">
                        <label slot="label" :style="$common.labelStyle('账簿')" v-html="'账簿'"></label>
                        <el-input v-model="abookName" @keyup.enter.native="openSearch('336844454858752', 0, 'abookName', 'abookName')" readonly>
                            <el-button @click="openSearch('336844454858752', 0, 'abookName', 'abookName')" slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmPay">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog title="审核" center :visible.sync="reviewDataBox" append-to-body>
            <el-form @submit.native.prevent :model="sendDataInfo" label-position="top">
                <el-row>
                    <el-form-item label="审核意见">
                        <label slot="label" :style="$common.labelStyle('审核意见')" v-html="'审核意见'"></label>
                        <el-radio-group v-model="sendDataInfo.state">
                            <el-radio-button label="2">同意</el-radio-button>
                            <el-radio-button label="-1">不同意</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="reviewDataBox = false">取 消</el-button>
                <el-button type="primary" @click="submitDataAction()">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Vue from "vue";
import SearchScheme from "@/byComponents/SearchScheme.vue";
import ExtractionScheme from "@/byComponents/ExtractionScheme.vue";
import supplierBankAction from "@/components/supplierBankAction.vue";
import NP from "number-precision";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme,
        supplierBankAction
    },
    data() {
        //这里存放数据
        return {
            requesUrl: '',
            tableHeight: 0,
            getRequestData: {
                unitName: "",
                page: 1,
                rows: 30,
                unitId: "",
                start:
                    new Date(new Date().toLocaleDateString()).getTime() -
                    31 * 24 * 3600 * 1000,
                end:
                    new Date(new Date().toLocaleDateString()).getTime() +
                    24 * 60 * 60 * 1000 -
                    1,
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            ormId: JSON.parse(sessionStorage.getItem('userInfo')).ormId,
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            exId: "",
            seId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            DialogVisible: false,
            DialogExtract: false,
            seType: "",
            smId: "",
            isShowTooltip: false,
            showStatus: false,
            actionData: {},
            parentSearchData: {},
            sField: "",
            editVisible: false,
            abookId: "",
            abookName: "",
            payMoney: "",
            seType: "",
            reviewDataBox: false,
            sendDataInfo: {
                state: "2",
            },
            allMoney: 0
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.smName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.smId = "";
                }
            },
            deep: true,
        },
        abookName: {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.abookId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        async submitDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            var delData = {
                id: dataInfo.upId,
                state: this.sendDataInfo.state,
            };
            let responseData = await this.$http.aduitUnitPay(delData);
            if (responseData.status == 200) {
                this.$message({
                    type: "success",
                    message: responseData.message,
                });
                this.reviewDataBox = false;
                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async confirmPay() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            var delData = {
                abookId: this.abookId,
                upId: dataInfo.upId,
            };
            let responseData = await this.$http.confirmPayUnitPay(delData);
            if (responseData.status == 200) {
                this.$message({
                    type: "success",
                    message: responseData.message,
                });
                this.editVisible = false;
                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 子组件触发
        drawerCancel(commitData) {
            this.showStatus = false;
            commitData && this.getDataList();
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: {
                            isPenetrate,
                        }, //参数
                    },
                    "*"
                );
            }
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                console.log(val);
                this.DialogVisible = false;
                if (this.seType == "abookName") {
                    this.abookName = val.abookName;
                    this.abookId = val.abookId;
                    return;
                }
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        getExtractName(e) {
            console.log(e);
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.seType = type;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        isShowData(name, value) {
            switch (name) {
                case "supplier":
                    var dataInfo = sessionStorage.getItem("selectSupplierData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.getRequestData.psomBuycus = dataInfo.smId;
                        this.getRequestData.smName = dataInfo.smName;
                    }
                    break;
            }
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId],
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList;
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30, false)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30, false)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                this.getButtonList();
                // this.formDataList = [];
                // this.pageShowData.forEach((item, i) => {
                //   if (i > 3) this.formDataList.push(this.pageShowData[i]);
                // });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType);
            switch (actionData.actionType) {
                case 0:
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.abookId = "";
                    this.abookName = "";
                    this.editVisible = true;
                    break;
                case 5:
                    this.sendDataInfo.state = "2";
                    this.reviewDataBox = true;
                    break;
                case 6://导出
                    this.exportFun()
                    break;
                case 7://退回
                    this.sendBack()
                    break;
            }
        },
        sendBack() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("是否退回该单据?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    const responseData = await this.$http.unitPayback({ ids: [dataInfo.upId] })
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });
                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                }).catch((action) => {

                });
        },
        async exportFun() {
            if (this.returnData.list.length == 0) {
                this.$message({ type: 'error', message: "暂无数据！" })
                return
            }
            window.location.href = this.requesUrl + '/unitPay/exportDescibUnitPayVo?ormId=' + String(this.ormId)
                + '&start=' + this.getRequestData.start + '&end=' + this.getRequestData.end
                + '&unitName=' + this.getRequestData.unitName

        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path);
            this.$refs["customDesign"].openBox(
                pathInfo.jurId,
                this.pageShowData,
                pathInfo.jurName
            );
        },
        examine() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$prompt("请输入实际提现金额", "提现审核", {
                confirmButtonText: "同意",
                cancelButtonText: "拒绝",
            })
                .then(({ value }) => {
                    this.setMoney(value, 2);
                })
                .catch((action) => {
                    console.log(action);
                    if (action == "cancel") {
                        this.setMoney("", -1);
                    }
                });
        },
        async setMoney(value, type) {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            var delData = {
                actualMoney: value,
                upId: dataInfo.upId,
                comState: type,
            };
            let responseData = await this.$http.setActualMoney(delData);
            if (responseData.status == 200) {
                this.$message({
                    type: "success",
                    message: "操作成功!",
                });
                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.queryTaskUnitPay(
                this.getRequestData
            );
            if (responseData && responseData.status == 200) {
                let resData = JSON.parse(JSON.stringify(responseData));
                this.returnData.list = resData.result.list;
                this.allMoney = 0
                this.returnData.list.forEach(item => {
                    if (item.payMoney != '' && item.payMoney != undefined && item.payMoney != null) {
                        this.allMoney += item.payMoney || 0
                    }
                })
                this.allMoney = NP.round(this.allMoney, 2)
                this.returnData.pages = resData.result.pages;
                this.returnData.total = resData.result.total;
                this.returnData.pageNum = resData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }

            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.sbiId],
                    };
                    let responseData = await this.$http.deleteSupBankinfo(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        //获取状态
        getIsGsp(str, val) {
            try {
                str && str.replace(/\\/g, "");
                let arr = JSON.parse(str);
                let len = arr.length;
                let newStr = "";
                for (let i = 0; i < len; i++) {
                    if (arr[i].key === val) {
                        newStr = arr[i].value;
                        break;
                    }
                }
                return newStr;
            } catch (ex) {
                return str;
            }
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton();
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
        this.requesUrl = this.$store.getters.getConfig.requestUrl;
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}
</style>